import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './guestLayout.css';

const GuestLayout = ({ }) => {
  const { t } = useTranslation();
  return (
    <div className="guest-layout">
      {/* <div className='auth-topbar'></div> */}
      <Outlet />
    </div>
  );
};

export default GuestLayout;
